import allAuthApi from '../../api/auth'
import router from '../../router'
import VueCookies from 'vue-cookies'
import {STATUS_TITLE, STATUS_MESSAGE} from '@/utils/notificationMessage'
import Vue from 'vue'
import errorMessage from '../../utils/errormessage'

export const state = () => ({
  user: {
    name: '',
    avatar: '',
    roleName: '',
    phone: '',
    email: '',
    position: '',
    employeeCode: '',
    notification_status: '',
    company_id: ''
  },
  errorMessage: {
    passwordOrEmail: '',
    currentPassword: ''
  },
  isSuccess: false,
  errorEmailReset: '',
  errorPasswordReset: '',
  errorMyPage: '',
  errorContact: '',
  nameAdmin: '',
  editMyPage: {

  },
  companyName: '',
  userCompanyIds: null
})

export const getters = {
  errorMessage: state => {
    return state.errorMessage
  },
  userCompanyIds: state => {
    return state.userCompanyIds
  }
}

export const mutations = {
  CHANGE_USER (state, slug) {
    state.user = { ...slug }
    state.nameAdmin = slug.name
    state.editMyPage = { ...slug }
  },
  CHANGE_COMPANY_NAME (state, slug) {
    state.companyName = slug
  },
  CHANGE_ERROR_VALIDATE (state, slug) {
    state.errorMessage = { ...slug }
  },
  CHANGE_EMAIL (state, slug) {
    state.errorEmailReset = slug.email
  },
  CHANGE_ERROR_MY_PAGE (state, slug) {
    state.errorMyPage = { ...slug }
  },
  CHANGE_ERROR_CONTACT (state, slug) {
    state.errorContact = { ...slug }
  },
  CHANGE_PASSWORD_OR_EMAIL (state, slug) {
    state.errorMessage.currentPassword = slug
  },
  CHANGE_INCORRECT_CURRENT_PASSWORD (state, slug) {
    state.errorMessage = slug
  },
  SET_SUCCESS_FLAG (state, slug) {
    state.isSuccess = slug
  },
  USE_COMPANY_IDS (state, slug) {
    state.userCompanyIds = slug
  }
}

export const actions = {
  async login ({commit}, param) {
    try {
      const res = await allAuthApi.login(param)
      if (res.status === 201) {
        VueCookies.set('token', res.data.data.token)
        commit('CHANGE_USER', res.data.data)
        commit('CHANGE_ERROR_VALIDATE', '')
        if (res.data.data.role_name === 'manager') {
          router.push('/manager/dashboard')
        } else if (res.data.data.role_name === 'admin') {
          router.push('/admin/dashboard')
        } else {
          router.push('/employee/dashboard')
        }
      }
    } catch (error) {
      if (error.response.status === 401) {
        commit('CHANGE_PASSWORD_OR_EMAIL', 'email or password is incorrect')
        new Vue().$toastr.e(errorMessage.errorEmail('email or password is incorrect'))
        return true
      }
    }
  },
  async resetPassWord ({commit}, params) {
    try {
      const res = await allAuthApi.forgotPassword({...params.formData})
      if (res.status === 201) {
        params.modal.show()
        commit('CHANGE_ERROR_VALIDATE', '')
      }
    } catch (error) {
      params.modal.hide()
      if (error.response.status === 400) {
        commit('CHANGE_EMAIL', error.response.data.error)
      }
    }
  },
  async changePassword ({commit}, params) {
    try {
      const res = await allAuthApi.changePassword(params)
      if (res.status === 204) {
        router.push('/login')
      }
    } catch (error) {
      if (error.response.status === 400) {
        commit('CHANGE_RESET_PASS', error.response.data.error)
      }
    }
  },
  async profileChangePassword ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await allAuthApi.accountChangePassword(params)
      if (res.status === 204) {
        vm.$toastr.s(STATUS_TITLE.SUCCESS, STATUS_MESSAGE.UPDATED)
        commit('SET_SUCCESS_FLAG', true)
      }
    } catch (error) {
      if (error.response.status === 400) {
        commit('CHANGE_INCORRECT_CURRENT_PASSWORD', error.response.data.error)
      }
    }
  },
  async checkTokenResetPassword ({commit}, token) {
    try {
      await allAuthApi.checkToken(token)
    } catch (error) {
      if (error.response.status === 401) {
        router.push('/401')
      } else if (error.response.status === 400) {
        router.push('/error')
      }
    }
  },
  logout ({commit}) {
    VueCookies.remove('token')
    router.push('/login')
  },
  async getLoadProfile ({commit}, params) {
    try {
      const res = await allAuthApi.getProfile(params)
      if (res.status === 200) {
        if (res.data.data.role_name === 'manager') {
          router.push('/manager/dashboard')
        } else if (res.data.data.role_name === 'admin') {
          router.push('/admin/dashboard')
        } else {
          router.push('/employee/dashboard')
        }
      }
    } catch (error) {

    }
  },
  async getProfile ({commit}, params) {
    try {
      const res = await allAuthApi.getProfile(params)
      if (res.status === 200) {
        commit('CHANGE_USER', res.data.data)
        if (res.data.data.company_name) {
          commit('CHANGE_COMPANY_NAME', res.data.data.company_name)
        }
        return res.data.data
      }
    } catch (error) {

    }
  },
  async editProfile ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await allAuthApi.editProfile(params)
      if (res.status === 201) {
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
        commit('CHANGE_USER', res.data.data)
        router.push('/manager/me')
      }
    } catch (error) {
      commit('CHANGE_ERROR_MY_PAGE', error.response.data.error)
    }
  },
  async editProfileEmployee ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await allAuthApi.editProfile(params)
      if (res.status === 201) {
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
        commit('CHANGE_USER', res.data.data)
        commit('CHANGE_ERROR_MY_PAGE', '')
      }
    } catch (error) {
      commit('CHANGE_ERROR_MY_PAGE', error.response.data.error)
    }
  },
  async editProfileEmployeeMyPage ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await allAuthApi.editProfile(params)
      if (res.status === 201) {
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
        commit('CHANGE_USER', res.data.data)
        commit('CHANGE_ERROR_MY_PAGE', '')
      }
      router.push('/employee/me')
    } catch (error) {
      commit('CHANGE_ERROR_MY_PAGE', error.response.data.error)
    }
  },
  async editProfileAdmin ({commit}, params) {
    let vm = new Vue()
    try {
      const res = await allAuthApi.editProfile(params)
      if (res.status === 201) {
        commit('CHANGE_USER', res.data.data)
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
        router.push('/admin/me')
      }
    } catch (error) {
      commit('CHANGE_ERROR_MY_PAGE', error.response.data.error)
    }
  },
  async registerContact ({commit}, params) {
    try {
      const res = await allAuthApi.registerContact(params.params)
      if (res.status === 201) {
        params.callback.onSuccess()
        commit('CHANGE_ERROR_CONTACT', '')
        commit('CHANGE_ERROR_VALIDATE', '')
      }
    } catch (error) {
      if (error.response.status === 400) {
        commit('CHANGE_ERROR_CONTACT', error.response.data.error)
      } else if (error.response.status === 500) {
        params.callback.onError()
      }
    }
  },
  async getUserCompanyIds ({commit}, params) {
    try {
      const res = await allAuthApi.getUserCompanyIds(params)
      if (res.status === 200) {
        commit('USE_COMPANY_IDS', res.data.data)
      }
    } catch (error) {
      console.warn('getUserCompanyIds API Error: ', error.response.data.error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/all/auth.js